// extracted by mini-css-extract-plugin
export default {"content":"home_content__WLHc8","headerRow":"home_headerRow__0kZzW"};